import React from "react";
import { Box, Typography } from "@mui/material";
import { SearchOff } from "@mui/icons-material";

const NoDataMessage = ({ selectedCarePlan }) => {
  return (
    <Box sx={{ textAlign: "center", py: 10 }}>
      <SearchOff sx={{ fontSize: 64, color: "#94a3b8", mb: 2 }} />
      <Typography variant="h6" fontWeight={600} color="#475569">
        No Assessments Found
      </Typography>
      <Typography variant="body2" color="#94a3b8" sx={{ mt: 1 }}>
        {selectedCarePlan 
          ? "No assessments are assigned to this care plan yet."
          : "No assessments are assigned to this client yet."}
      </Typography>
      <Typography variant="caption" color="#cbd5e1" sx={{ mt: 0.5, display: "block" }}>
        {selectedCarePlan 
          ? "Please select a different care plan or assign assessments from the care plan page."
          : "Please assign assessments from the care plan page."}
      </Typography>
    </Box>
  );
};

export default NoDataMessage;